export const ROOT = '/InterviewsAPI';
export const EMAILPREVIEWROOT = '/EmailPreviewAPI';
export const LIST = `${ROOT}/getinterviewpage`;
export const EXPORT = `${ROOT}/export`;
export const MANCOM_EXPORT = `${ROOT}/mancomexport`;
export const GET_INTERVIEWER_DETAIL = `${ROOT}/GetInterviewerLatestDetail`;
export const GET_APPLICANT_DETAIL = `${ROOT}/GetApplicantLatestDetail`;
export const GET_STATUS = `${ROOT}/getstatus`;
export const GET_HOLIDAY_DATES = `${ROOT}/getholidaydates`;
export const FILTERED_UPDATED_APPLICANT= `${ROOT}/getfilteredupdateapplicantddl`;
export const POSITION_LEVEL = `${ROOT}/getpositionlevelddl`;
export const GET_INTERVIEW_MODE = `${ROOT}/getinterviewmode`;
export const GET_INTERVIEW_ADD_EMAIL_PREVIEW = `${EMAILPREVIEWROOT}/getinterviewsaddemail`;
export const CREATE_INTERVIEW_ADD_WITH_EMAIL = `${ROOT}/createinterviewsaddwithemail`;
export const GET_INTERVIEW_DETAIL_EMAIL_PREVIEW = `${EMAILPREVIEWROOT}/getinterviewsdetailemail`;
export const UPDATE_INTERVIEW_DETAIL_WITH_EMAIL = `${ROOT}/updateinterviewsdetailwithemail`;
